<script setup lang="ts">
import HeaderBurgerIcon from '@/components/Header/HeaderBurgerIcon.vue'

type Props = {
  isActive: boolean
}

defineProps<Props>()
</script>

<template>
  <the-button
    class="header-burger"
    variant="transparent"
    size="sm"
    radius="lg"
    aria-label="Открыть меню"
  >
    <header-burger-icon :is-active="isActive" />
  </the-button>
</template>

<style lang="scss">
.header-burger {
  padding: 0 !important;
  color: var(--ui-text-primary) !important;
}
</style>
